import { TeamAccessDTO } from '../team/team-access.dto';

export class WikiCategoryListDTO extends TeamAccessDTO {

    name: string;

    description: string;

}
